import React from 'react';
import {Avatar, Dropdown, Menu} from 'antd';
import {AiOutlineUser} from "react-icons/ai";
import {IoDocumentsOutline, IoLogOutOutline, IoSettingsOutline} from "react-icons/io5";
import {useDispatch, useSelector} from "react-redux";
import {NavLink} from 'react-router-dom';

import classes from './PersonalProfileToggle.module.scss';
import {logout} from '../../../store/actions/auth'

const PersonalProfileToggle = (props) => {
    const user = useSelector(state => state.auth.user);
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(logout()).then(() => {
            if (props.location.pathname.includes('personal-account') ||
                props.location.pathname.includes('new-password') ||
                props.location.pathname.includes('reset-password') ||
                props.location.pathname.includes('admin'))
                props.history.push('/')
        })
    }

    const setActiveClass = () => {
        let activeClassName = ''
        const currentPathName = (user.authorities.indexOf("ROLE_ADMIN") !== -1) ? "/admin" : "/personal-account/profile"
        if (props.location.pathname === currentPathName) activeClassName = 'PersonalProfileToggle_active'
        return activeClassName
    }

    const menu = (
        <Menu
            items={[
                user && {
                    key: '0',
                    label: <div className={`${classes.fioContainer} PersonalProfileToggle_title_color`}>
                        {user.fio}
                    </div>,
                    style: { pointerEvents: 'none' }
                },
                {
                    key: '1',
                    label: <NavLink
                        exact
                        to={(user.authorities.indexOf("ROLE_ADMIN") !== -1) ? "/admin" : "/personal-account/profile"}>
                        Личный кабинет
                    </NavLink>,
                    icon: <AiOutlineUser size={20} />,
                    className:  setActiveClass()
                },
                // (user.authorities.indexOf("ROLE_ADMIN") === -1) && {
                //     key: '2',
                //     label: <NavLink
                //         exact
                //         to="/personal-account/notifications" >
                //         Уведомления
                //     </NavLink>,
                //     icon: <AiOutlineBell size={20} />,
                //     className: props.location.pathname === "/personal-account/notifications" ? 'PersonalProfileToggle_active' : ''
                // },
                (user.authorities.indexOf("ROLE_ADMIN") === -1) && {
                    key: '3',
                    label: <NavLink
                        exact
                        to="/personal-account/settings">
                        Настройки
                    </NavLink>,
                    icon: <IoSettingsOutline size={20} />,
                    className: props.location.pathname === "/personal-account/settings" ? 'PersonalProfileToggle_active' : ''
                },
                (user.authorities.indexOf("ROLE_ADMIN") !== -1) && {
                    key: '4',
                    label: (
                        <div onClick={() => window.location.href = process.env.REACT_APP_BASEURL + '/api/v1/swagger'}
                             style={{width: '100%'}}>
                            Документация
                        </div>
                    ),
                    icon: <IoDocumentsOutline size={20}/>
                },
                {
                    key: '5',
                    label: (
                        <div onClick={() => handleClick()} style={{width: '100%'}}>
                            Выйти
                        </div>
                    ),
                    icon: <IoLogOutOutline size={20} />
                },
            ]}
        />
    );

    return (
        <Dropdown overlay={menu} placement="bottomRight" arrow trigger={['click']} overlayStyle={{maxWidth: '250px'}}>
            <Avatar 
            src={user.photoUrl} 
            size={50} 
            style={{ cursor: 'pointer', minWidth: '50px' }} 
            icon={<AiOutlineUser style={{ position: 'relative', top: '-3px' }} />} alt="profile" />
        </Dropdown>
    )
};

export default PersonalProfileToggle;